































import { Component, Vue } from 'vue-property-decorator';
import { OpeningHour } from '@/models/Retailer';

@Component
export default class RetailerOpeningHours extends Vue {
    protected openingHours!: OpeningHour[];
    protected todayOpeningHour!: OpeningHour;
    protected openingHoursOpen: boolean = false;

    constructor() {
        super();
        const openingHours = JSON.parse(this.$attrs['data-openinghours']);
        if (openingHours) {
            this.todayOpeningHour = openingHours.shift();
            this.openingHours = openingHours;
        }
    }
    mounted() {}

    get contactPageLink(): string {
        return this.$attrs['data-contact-link'];
    }

    private toggleDropdown() {
        this.openingHoursOpen = !this.openingHoursOpen;

        if (document.body.classList.contains('disable-scroll--small-to-large')) {
            document.body.classList.remove('disable-scroll--small-to-large');
        } else {
            document.body.classList.add('disable-scroll--small-to-large');
        }
    }
}
